var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83569 4.04163L11.794 7.99996L7.83569 11.9583L8.95528 13.0779L13.4734 8.55975C13.6219 8.41129 13.7053 8.20992 13.7053 7.99996C13.7053 7.79 13.6219 7.58863 13.4734 7.44017L8.95528 2.92204L7.83569 4.04163Z",
    fill: "#00A4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29419 4.04163L6.25253 7.99996L2.29419 11.9583L3.41377 13.0779L7.93191 8.55975C8.08037 8.41129 8.16378 8.20992 8.16378 7.99996C8.16378 7.79 8.08037 7.58863 7.93191 7.44017L3.41378 2.92204L2.29419 4.04163Z",
    fill: "#00A4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.8f9b47d4aaa37ba7de28a09590a81afe.svg";
export { ForwardRef as ReactComponent };